import { useState } from "react";
import {ArrowRight, SlidersHorizontal} from 'lucide-react';

const categories = [
  "Todos",
  "Mangueiras Hidráulicas",
  "Conexões e Terminais",
  "Correias",
  "Pneumática",
  "Ferramentas",
  "EPI e Outros",
];

const products = [
  {
    category: "Mangueiras Hidráulicas",
    name: "Mangueiras Hidráulicas SAE",
    desc: "Linhas 1SN, 2SN, 4SP, 4SH – alta pressão para aplicações industriais e agrícolas.",
    image: "https://static.lumi.new/2a/2a32655921f1e5bd87b99ae629e28f7a.png",
    tags: ["SAE 100R1", "SAE 100R2", "SAE 100R4"],
  },
  {
    category: "Mangueiras Hidráulicas",
    name: "Mangueiras Multipressão",
    desc: "Versatilidade para múltiplas aplicações com diferentes pressões de trabalho.",
    image: "https://static.lumi.new/30/3073fa20bf7b4446c31c2b5ebe088aa6.png",
    tags: ["2 vias", "4 vias", "Espiral"],
  },
  {
    category: "Mangueiras Hidráulicas",
    name: "Mangueiras Industriais",
    desc: "Para vapor, ar comprimido, combustível, abrasivos e sucção de fluidos.",
    image: "https://static.lumi.new/95/953a8b7d134063d140c4eeb35d519a0f.png",
    tags: ["Vapor", "Combustível", "Sucção"],
  },
  {
    category: "Conexões e Terminais",
    name: "Terminais Hidráulicos",
    desc: "BSP, NPT, JIC, ORFS, Métrico e Flanges – ampla linha de conexões.",
    image: "https://static.lumi.new/a8/a847563e4a5ac2695956f138604654f3.png",
    tags: ["BSP", "NPT", "JIC", "ORFS"],
  },
  {
    category: "Conexões e Terminais",
    name: "Adaptadores e Cotovelos",
    desc: "Adaptadores em aço carbono e inox, cotovelos 45° e 90°, tees e cruzetas.",
    image: "https://static.lumi.new/33/33ba25418cdb50a63bbb8e8f7b2a9ecc.png",
    tags: ["Aço Carbono", "Inox", "Latão"],
  },
  {
    category: "Correias",
    name: "Correias em V e Sincronizadoras",
    desc: "Perfis A, B, C, D e SPZ, SPA, SPB para transmissão de potência.",
    image: "https://static.lumi.new/02/022839ffe819448fd8bf98122646d646.png",
    tags: ["Perfil A/B/C", "SPZ/SPA/SPB", "Sincronizadoras"],
  },
  {
    category: "Pneumática",
    name: "Componentes Pneumáticos",
    desc: "Cilindros, válvulas, filtros, reguladores e lubrificadores para sistemas pneumáticos.",
    image: "https://static.lumi.new/f0/f076a33e1ffd7bf2940f6ee011256de6.png",
    tags: ["Cilindros", "Válvulas", "FRL"],
  },
  {
    category: "Ferramentas",
    name: "Ferramentas Manuais",
    desc: "Chaves, alicates, torquímetros, cortadores de mangueira e ferramentas para instalação hidráulica.",
    image: "https://static.lumi.new/39/39dc37777110b37f8150f189c3012918.png",
    tags: ["Chaves", "Torquímetro", "Cortadores"],
  },
  {
    category: "Ferramentas",
    name: "Ferramentas Elétricas e de Bancada",
    desc: "Furadeiras, esmerilhadeiras, parafusadeiras e conjuntos de soquetes para manutenção industrial.",
    image: "https://static.lumi.new/85/8524f5aeef2dd33d82b7265009f48cdb.png",
    tags: ["Furadeiras", "Esmerilhadeiras", "Soquetes"],
  },
  {
    category: "EPI e Outros",
    name: "EPIs e Segurança",
    desc: "Equipamentos de proteção individual e coletiva para ambientes industriais.",
    image: "https://static.lumi.new/e1/e14ea8595f5cac8b52f92856e1505ee2.png",
    tags: ["Capacetes", "Luvas", "Botas"],
  },
];

export default function Products() {
  const [active, setActive] = useState("Todos");

  const filtered =
    active === "Todos" ? products : products.filter((p) => p.category === active);

  return (
    <section id="produtos" className="bg-[#f5f6fa] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">

        {/* ── Header ── */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-6">
          <div>
            <span className="inline-flex items-center gap-3 text-[#F5A623] font-black uppercase tracking-[0.25em] text-xs mb-4">
              <span className="w-10 h-px bg-[#F5A623]" />
              Catálogo de Produtos
            </span>
            <h2 className="font-barlow-condensed text-5xl md:text-7xl font-black text-[#0D1B3E] uppercase leading-[0.9]">
              Nossos Produtos
            </h2>
            <p className="mt-4 text-gray-500 text-lg max-w-lg leading-relaxed font-light">
              Linha completa de mangueiras, conexões, correias, ferramentas e acessórios para todos os segmentos industriais.
            </p>
          </div>
          <div className="hidden md:flex items-center gap-2 text-gray-400 text-sm font-semibold uppercase tracking-wider">
            <SlidersHorizontal size={16} className="text-[#F5A623]" />
            Filtrar por categoria
          </div>
        </div>

        {/* ── Filter tabs ── */}
        <div className="flex flex-wrap gap-2 mb-12">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActive(cat)}
              className={`px-5 py-2.5 rounded-full text-sm font-bold uppercase tracking-wide transition-all duration-200 ${
                active === cat
                  ? "bg-[#F5A623] text-[#0D1B3E] shadow-lg shadow-[#F5A623]/25 scale-105"
                  : "bg-white text-gray-500 hover:text-[#0D1B3E] border border-gray-200 hover:border-[#F5A623]/40 hover:shadow-md"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* ── Products grid ── */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {filtered.map((product) => (
            <div
              key={product.name}
              className="card-lift bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-[#F5A623]/30 hover:shadow-[0_28px_56px_-16px_rgba(13,27,62,0.25)] group"
            >
              {/* Image */}
              <div className="img-zoom relative h-52">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B3E]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
                <span className="absolute top-3 left-3 bg-[#F5A623] text-[#0D1B3E] text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest shadow-md">
                  {product.category.split(" ")[0]}
                </span>
              </div>

              {/* Body */}
              <div className="p-5">
                <h3 className="text-[#0D1B3E] font-bold text-sm mb-2 leading-snug tracking-tight">
                  {product.name}
                </h3>
                <p className="text-gray-400 text-xs leading-relaxed mb-4">{product.desc}</p>

                {/* Tags */}
                <div className="flex flex-wrap gap-1.5 mb-5">
                  {product.tags.map((tag) => (
                    <span
                      key={tag}
                      className="bg-[#0D1B3E]/6 text-[#0D1B3E] text-[10px] px-2.5 py-1 rounded-full font-semibold border border-[#0D1B3E]/8 uppercase tracking-wide"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <a
                  href="#contato"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector("#contato")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="flex items-center gap-1.5 text-[#F5A623] font-bold text-xs uppercase tracking-wider hover:gap-3 transition-all duration-200 group/cta"
                >
                  Solicitar Orçamento
                  <ArrowRight size={13} className="group-hover/cta:translate-x-0.5 transition-transform" />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* ── Bottom CTA ── */}
        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4 pt-10 border-t border-gray-200">
          <p className="text-gray-500 text-sm">Precisa de algo específico?</p>
          <a
            href="https://wa.me/5521973516085?text=Olá! Gostaria de solicitar um orçamento."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#0D1B3E] hover:bg-[#162952] text-white font-black px-9 py-4 rounded-xl text-sm uppercase tracking-widest transition-all duration-300 hover:-translate-y-0.5 shadow-xl shadow-[#0D1B3E]/25 hover:shadow-[#0D1B3E]/40"
          >
            Solicitar Orçamento Personalizado
          </a>
        </div>
      </div>
    </section>
  );
}
